import React, {
  Children,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import "./NFLookupCatalog.css";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";
import { ValidationStatus } from "devextreme/common";
import MoreDetailsIcon from "../../../assets/img/svg/MoreDetailsIcon";
import { Popup, ScrollView } from "devextreme-react";
import {
  AppEntities,
  AppEntitiesCatalogs,
  IAppEntity,
  AppEntitiesArray,
} from "../../../config/entities";
import "./NFLookupSearchCatalog.css";
import Search from "../../../assets/img/svg/Search";
import DropDownArrowIcon from "../../../assets/img/svg/DropDownArrowIcon";
import { Popover } from "devextreme-react";
import {
  Controller,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form";
import { NewCatalogModalView } from "../NewCatalogModalView";
import CatalogContext from "../../Pages/RS/Context/CatalogContext";

interface IProps {
  title?: string;
  fieldName: string;
  entity?: any;
  children?: React.ReactNode;
  serverData?: (searchText: string | undefined) => Promise<any[]>;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  index?: number;
  tableName?: string;
  tableFieldName?: string;
  onValueChanged?: (e: any, index: number) => void;
  value?: any;
  displayFieldName?: string;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
  searchText?: string;
  setSearchText?: React.Dispatch<React.SetStateAction<string>>;
}

interface ICallbackProps {
  onSelect: () => void;
  onValueChanged: (e: any, index: number) => void;
}

export const NFLookupSearchBaseDocument = ({
  fieldName,
  entity,
  title,
  children,
  serverData,
  required,
  showBorder = true,
  width,
  index = 0,
  tableFieldName,
  tableName,
  onValueChanged,
  value,
  displayFieldName = "name",
  selectedCatalog,
  setSelectedCatalog,
  searchText,
  setSearchText,
}: IProps) => {
  const { register, control, watch, formState } = useFormContext();
  const { errors, dirtyFields } = useFormState();

  const [currentId, setCurrentId] = useState<string | undefined>(undefined);

  const [validationStatus, setValidationStatus] =
    useState<ValidationStatus>("valid");

  useEffect(() => {
    setCurrentId(watch(fieldName));
  }, [watch(fieldName)]);

  useEffect(() => {
    if (currentId) {
      loadDefaultItem();
    }
  }, [currentId]);

  const componentId =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(true);
  const [isPopoverVisible, setIsPopoverVisible] = useState<boolean>(false);

  const [selectedEntity, setSelectedEntity] = useState<IAppEntity | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(undefined);

  const [showCatalog, setShowCatalog] = useState<boolean>(true);

  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const [catalogModalViewOpen, setCatalogModalViewOpen] =
    useState<boolean>(false);

  const [detailModalViewOpen, setDetailModalViewOpen] =
    useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [items, setItems] = useState<any[]>([]);
  const popoverRef = useRef<Popover>(null);
  const arrayChildren = Children.toArray(children);
  // const [searchText, setSearchText] = useState("");

  const [searchResults, setSearchResults] = useState("");

  useContext(CatalogContext);

  const handleOpen = () => {
    setIsPopupVisible(false);
  };

  const handleClose = () => {
    setIsPopupVisible(true);
  };

  const handleEntityClick = (entity: IAppEntity) => {
    setSelectedEntity(entity);

    setIsPopupVisible(true);
    if (setSearchText) {
      setSearchText(entity.title);
    }
    setShowCatalog(false);
    if (setSelectedCatalog) {
      setSelectedCatalog(true);
    }
  };

  const filteredEntities = [
    AppEntities.PaymentRequests,
    AppEntities.VendorInvoices,
    AppEntities.PurchaseOrders,
    AppEntities.SalesOrders,
    AppEntities.CustomerInvoices,
    AppEntities.SalaryAccruals,
  ];
  // entity.title.toLowerCase().includes(searchResults.toLowerCase())

  const loadItems = async (searchText: string | undefined) => {
    try {
      setIsLoading(true);
      setIsError(false);
      setErrorMessage("");
      let searchTextValue = isPopoverVisible ? searchText : "";
      if (serverData) {
        const loadedItems = await serverData(searchTextValue);
        setItems(loadedItems);
      } else if (entity) {
        const dataService = entity.getDataService();
        const loadedItems = await dataService.GetAll(searchTextValue);
        setItems(loadedItems);
      } else {
        setItems([]);
      }
    } catch (e: any) {
      setIsError(true);
      setErrorMessage(e.message);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  };

  const loadDefaultItem = async () => {
    const item = await entity.getDataService().Get(currentId);
    setSelectedItemId(item.id);
    setSelectedItem(item);
    if (setSearchText) {
      setSearchText(item ? item[displayFieldName] : "");
    }
  };

  function handlePopoverHidden() {
    setIsPopoverVisible(false);
    if (!selectedItem) return;
    if (selectedItem[displayFieldName] !== searchText) {
      if (setSearchText) {
        setSearchText(selectedItem ? selectedItem[displayFieldName] : "");
      }
    }
  }

  const handleSelectItem = (item: any) => {
    setSelectedItem(item);
    if (setSearchText) {
      setSearchText(item ? item[displayFieldName] : "");
    }

    setIsPopoverVisible(false);
  };

  const handleClearText = () => {
    if (setSearchText) {
      setSearchText("");
    }

    setShowCatalog(true);
  };

  const handleSearchTextChange = async (inputEvent: any) => {
    const newSearchTextValue = inputEvent.event.originalEvent.target.value;

    if (newSearchTextValue !== searchText) {
      if (setSearchText) {
        setSearchText(newSearchTextValue);
      }

      setIsPopoverVisible(true);
      await loadItems(newSearchTextValue);
    }
  };

  function handleCatalogModalViewClosed() {
    setCatalogModalViewOpen(false);
  }

  const handleDetailModalViewClose = () => {
    setDetailModalViewOpen(false);
  };

  useEffect(() => {
    if (tableName && tableFieldName) {
      // console.log("tableName", tableName);
      // console.log("tableFieldName", tableFieldName);
      // console.log("fieldName", fieldName);
      // console.log("index", index);
      // console.log("errors", formState.errors);
      // console.log("tableerrors1", formState.errors);
      // //@ts-ignore
      // console.log("tableerrors2", formState.errors[tableName]);
      //@ts-ignore
      const errorTable = formState.errors[tableName];
      // console.log("errorTable", errorTable);
      if (errorTable) {
        //@ts-ignore
        const errorLine = errorTable[index];
        if (errorLine) {
          // console.log("errorLine", errorLine);
          const errorField = errorLine[tableFieldName];
          // console.log("errorField", errorField);
          if (errorField) {
            setValidationStatus("invalid");
            return;
          }
        }
      }
      setValidationStatus("valid");
      // return "valid";
    } else {
      // console.log("singleerrors", formState.errors);
      const status = formState.errors[fieldName]
        ? "invalid"
        : dirtyFields[fieldName]
        ? "valid"
        : "valid";
      // console.log("status", status);
      // console.log("errors", errors);
      setValidationStatus(status);
    }
  }, [formState]);

  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        rules={{
          required: required === true,
          onChange: (newValue: any) => {
            const newId = newValue?.target.value;

            if (newId) {
              const newItem = items.find((x) => x.id === newId);
              handleSelectItem(newItem);
              if (setSearchText) {
                setSearchText(newItem[displayFieldName]);
              }
            } else {
              handleSelectItem(undefined);
              if (setSearchText) {
                setSearchText("");
              }
            }
            if (onValueChanged) {
              onValueChanged(newValue.target.value, index);
            }
          },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => {
          return (
            <>
              <div className={title ? "form-group" : ""}>
                {title && <label className={"form-label-sm"}>{title}</label>}
                <div className="d-flex border rounded">
                  <TextBox
                    // value={searchText}
                    name={`searchTextBox${componentId}`}
                    width={width || undefined}
                    style={{ border: showBorder === true ? "none" : "block" }}
                    id={`searchTextBox${componentId}`}
                    validationStatus={validationStatus}
                    onInput={(e) => handleSearchTextChange(e)}
                    className="bg-light d-flex flex-row-reverse w-100"
                    disabled={true}
                  />
                  <div className="d-flex justify-content-end align-items-center moreDetails">
                    <div onClick={handleOpen}>
                      <MoreDetailsIcon />
                    </div>
                  </div>
                </div>
              </div>

              <Popup
                title="Choose entity type"
                visible={!isPopupVisible}
                onHiding={handleClose}
                resizeEnabled={true}
                hideOnOutsideClick={true}
                width={"500px"}
                height={"355px"}
              >
                <input
                  type="text"
                  value={searchResults}
                  onChange={(e) => setSearchResults(e.target.value)}
                  placeholder="Search entities"
                  className="entity-search-bar"
                />

                <ScrollView>
                  <ul className="entities-list">
                    {filteredEntities.map((entity: IAppEntity) => (
                      <li
                        key={entity.apiUrl}
                        className="popupList border"
                        onClick={() => {
                          handleEntityClick(entity);
                        }}
                      >
                        <div className="entity-list">{entity.title}</div>
                      </li>
                    ))}
                  </ul>
                </ScrollView>
              </Popup>
              <Popover
                target={`#searchTextBox${componentId}`}
                visible={isPopoverVisible}
                ref={popoverRef}
                onHidden={handlePopoverHidden}
                position={"bottom"}
              >
                <div className={"lookup-catalog-popover-table popover-content"}>
                  <ScrollView>
                    <div className="table-wrapper-scroll-y">
                      <table className="table bg-light">
                        <thead>
                          <tr>
                            {arrayChildren.map((field: any, index) => {
                              return <th key={index}>{field.props.caption}</th>;
                            })}
                          </tr>
                        </thead>

                        <tbody>
                          {items.map((item: any, index) => (
                            <tr
                              key={index}
                              style={{ cursor: "pointer" }}
                              onClick={() => onChange(item?.id)}
                            >
                              {arrayChildren.map((field: any, index) => {
                                return (
                                  <td key={index}>
                                    {item[field.props.fieldName]}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </ScrollView>

                  {/*{isLoading && <div className={"w-100"}>Loading...</div>}*/}
                  {/*{isError && <div className={"alert alert-danger"}>{errorMessage}</div>}*/}
                  {items.length === 0 && (
                    <div className={"popover-text mb-3"}>No items</div>
                  )}
                </div>
              </Popover>
              {selectedItem && catalogModalViewOpen && (
                <NewCatalogModalView
                  id={selectedItem.id}
                  entity={entity}
                  open={catalogModalViewOpen}
                  onClose={handleCatalogModalViewClosed}
                  setSearchText={setSearchText}
                  setSelectedItem={setSelectedItem}
                />
              )}

              {detailModalViewOpen && (
                <NewCatalogModalView
                  id={selectedItem?.id}
                  entity={entity}
                  open={detailModalViewOpen}
                  onClose={handleDetailModalViewClose}
                  setSearchText={setSearchText}
                  setSelectedItem={setSelectedItem}
                />
              )}
            </>
          );
        }}
      />
    </>
  );
};
